import React from "react";
import { Badge } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faCommentDots,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";

const STAGE_LABEL = {
  1: "Stage 1 · Auditor General",
  2: "Stage 2 · Release auditor",
};

const formatDateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * The audit trail for one release: every approval note and every exception, in
 * the order they were recorded. Exceptions are append-only, so this list is the
 * history — nothing here is edited or deleted by a later sign-off.
 */
const AuditTimeline = ({ entries = [] }) => {
  if (!entries.length) {
    return (
      <p className="text-muted mb-0">
        Nothing recorded yet. Approving or flagging this release adds the first entry.
      </p>
    );
  }

  return (
    <ol className="list-unstyled mb-0">
      {entries.map((entry) => {
        const isException = entry.kind === "exception";
        return (
          <li
            key={entry.id}
            className="d-flex gap-3 pb-3 mb-3 border-bottom"
            style={{ borderColor: "#e9ecef" }}
          >
            <span
              className={`d-inline-flex align-items-center justify-content-center rounded-circle ${
                isException ? "bg-danger" : "bg-success"
              }`}
              style={{ width: 32, height: 32, flex: "0 0 32px" }}
            >
              <FontAwesomeIcon
                icon={isException ? faExclamationTriangle : faCheckCircle}
                color="#fff"
                size="sm"
              />
            </span>
            <div className="flex-grow-1">
              <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                <strong>{entry.commented_by || "Auditor"}</strong>
                <small className="text-muted">
                  {STAGE_LABEL[Number(entry.stage)] || STAGE_LABEL[1]}
                </small>
                <small className="text-muted">· {formatDateTime(entry.created_at)}</small>
                {isException && entry.category ? (
                  <Badge bg="danger">{entry.category}</Badge>
                ) : (
                  <Badge bg="light" text="dark">
                    <FontAwesomeIcon icon={faCommentDots} className="me-1" />
                    Note
                  </Badge>
                )}
              </div>
              <div className="text-dark" style={{ whiteSpace: "pre-wrap" }}>
                {entry.remark}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default AuditTimeline;
